<script setup lang="ts">
const { siteOptions } = useSiteOptions();
</script>

<template>
  <div v-if="siteOptions" class="site-footer-copyright text-center md:text-left">
    © {{ new Date().getFullYear() }}
    <!--     {{ siteOptions.name }} -->
    {{ __("Les Îles de la Madeleine", "gestes") }}
  </div>
</template>
